import { render, staticRenderFns } from "./contactTable.vue?vue&type=template&id=4a0838ef&scoped=true"
import script from "./contactTable.vue?vue&type=script&lang=ts"
export * from "./contactTable.vue?vue&type=script&lang=ts"
import style0 from "./contactTable.vue?vue&type=style&index=0&id=4a0838ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0838ef",
  null
  
)

export default component.exports